import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterList } from 'src/components/filterList';
import { ActionBar, Header } from 'src/components/header';
import { StyledTypography } from 'src/components/subHeader/SubHeaderWithSorting.styled';
import { PATHS } from 'src/constants/paths';
import { useFilterAndSorting } from 'src/hooks';
import { lang } from 'src/utils';

import { useManageAssemblyTagPage } from './hooks/ManageAssemblyTagPage.hook';
import { ManageAssemblyTagGridTable } from './modules/manageAssemblyTagGridTable/manageAssemblyTagGridTable';

export const ManageAssemblyTagPage = () => {
  const navigate = useNavigate();

  const { onChangeParams, activeFilters, numberofResults, totalCount } =
    useManageAssemblyTagPage();

  const [isFuzzySearch, setIsFuzzySearch] = useState(
    !('name.list' in activeFilters),
  );
  useEffect(() => {
    setIsFuzzySearch(!('name.list' in activeFilters));
  }, [activeFilters]);

  const {
    onChangeKeyword,
    onRemoveKeyword,
    onChangeToExactMatch,
    onChangeToFuzzyMatch,
  } = useFilterAndSorting([], [], isFuzzySearch);
  const [filterListEpoch, setFilterListEpoch] = useState(0);
  const bumpEpoch = () => setFilterListEpoch((e) => e + 1);

  const onSearchTypeChange = () => {
    if (isFuzzySearch) {
      onChangeToExactMatch('name.regexp', 'name.list');
      setIsFuzzySearch(false);
    } else {
      onChangeToFuzzyMatch('name.list', 'name.regexp');
      setIsFuzzySearch(true);
    }
  };

  const onReset = () => {
    onChangeParams('name.regexp', []);
    onChangeParams('name.list', []);
    setIsFuzzySearch(true);
    onChangeKeyword('');
    bumpEpoch();
  };

  const shouldDisplayResultInfo = numberofResults != null && totalCount != null;
  const resultCountText = `${lang.Showing} ${numberofResults}/${totalCount}`;

  return (
    <Grid>
      <Header
        title={lang.manageAssemblyTags}
        backLink={-1}
        actionBar={
          <ActionBar
            title={lang.assemblyTags}
            numResults={numberofResults ?? 0}
            onHandleClick={() => navigate(PATHS.ASSEMBLY_TAGS_ADD)}
          />
        }
        breadcrumbItems={[
          {
            label: 'Assemblies',
            link: `${PATHS.ASSEMBLIES}`,
          },
          {
            label: 'Tags',
            link: `${PATHS.ASSEMBLY_MANAGE_TAGS}`,
          },
        ]}
      />

      <Grid container spacing={4}>
        <Grid item xs={12} md={3} mt={3}>
          <FilterList
            key={`filterlist-${filterListEpoch}`}
            onChangeKeyword={onChangeKeyword}
            onRemoveKeyword={onRemoveKeyword}
            onChangeFilter={onChangeParams}
            showReset
            onReset={onReset}
            readOnly
            hasExactSearch
            onSearchTypeChange={onSearchTypeChange}
            isFuzzySearch={isFuzzySearch}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          {shouldDisplayResultInfo && (
            <StyledTypography paddingTop={4}>
              {`${resultCountText}`}
            </StyledTypography>
          )}

          <ManageAssemblyTagGridTable />
        </Grid>
      </Grid>
    </Grid>
  );
};
